import { REMOVE_WIDGET_ID, RESET_WIDGET_IDS, UNIMPORT_WIDGET_ID, UpdatedWidgetID } from "./types";


export function addWidgetId(widgetID: string): UpdatedWidgetID {
    return {
        type: UNIMPORT_WIDGET_ID,
        data: widgetID
    }
}

export function resetWidgetIds(): UpdatedWidgetID {
    return {
        type: RESET_WIDGET_IDS
    }
}

export function removeWidgetId(widgetID: string): UpdatedWidgetID {
    return {
        type: REMOVE_WIDGET_ID,
        data: widgetID
    }
}
